import React from "react";
import { Link } from "react-router-dom";
import { Shield, ArrowLeft } from "@phosphor-icons/react";

/**
 * Pagina "Accesso negato" — mostrata quando un utente prova ad accedere a una
 * sezione non autorizzata per il proprio ruolo (RBAC).
 */
export default function Forbidden() {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-6">
      <div className="text-center max-w-md" data-testid="forbidden-page">
        <div className="mx-auto w-16 h-16 rounded-full bg-red-100 flex items-center justify-center mb-4">
          <Shield size={32} weight="fill" className="text-red-600" />
        </div>
        <div className="label-eyebrow text-red-600">Accesso negato</div>
        <h1 className="font-display text-3xl md:text-4xl font-bold tracking-tight mt-2 mb-3">
          Non hai i permessi necessari per visualizzare questa pagina
        </h1>
        <p className="text-sm text-slate-600 mb-6">
          Questa sezione è riservata a determinati ruoli. Se pensi che sia un errore,
          contatta l'amministratore del tuo account.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/dashboard"
            className="inline-flex items-center justify-center gap-2 px-4 py-2 rounded-md ht-gradient text-white font-medium text-sm"
            data-testid="forbidden-back-home"
          >
            <ArrowLeft size={14} /> Torna alla tua dashboard
          </Link>
        </div>
      </div>
    </div>
  );
}
